import { render, staticRenderFns } from "./AdministratorAssignment.vue?vue&type=template&id=2c4106b1&scoped=true&"
import script from "./AdministratorAssignment.vue?vue&type=script&lang=js&"
export * from "./AdministratorAssignment.vue?vue&type=script&lang=js&"
import style0 from "./AdministratorAssignment.vue?vue&type=style&index=0&id=2c4106b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4106b1",
  null
  
)

export default component.exports